const getCardResponse = (rawData: any) => {
  const result = rawData?.data?.data
  const transformedData: ResponseType = result?.map(
    (topPerformingTools: any) => {
      const { id, type, tool, project, contributions } =
        topPerformingTools || {}
      return {
        id,
        tool,
        type,
        project,
        contributions,
      }
    },
  )

  return {
    data: transformedData,
    info: rawData?.data?.meta?.info,
  }
}

const topPerformingToolsFormattedResponses = {
  getCardResponse,
}

export default topPerformingToolsFormattedResponses
